module.exports = __webpack_public_path__ + "img/cubs-sculpture.8932b5ad.png";